import {
    APIResponse,
    OrderDto,
    OrderPaymentDetailsDto,
    OrdersSortDirection,
    OrderStatus,
    OrderVehicleDto,
} from "@/shared/api-contract/api-contract";
import { useI18n } from "@/shared/composables/use-i18n";
import { setup } from "vue-class-component";
import { Model, Options, Prop, Vue } from "vue-property-decorator";
import "./table-item.scss";
import OrderVehicleItem from "@/dashboard/my-orders/orders-table/table-item/order-vehicle-item.vue";
import { appAxios } from "@/core/utils/appAxios";
import UploadCmrPopup from "@/dashboard/my-orders/new-popup/upload-cmr-popup/upload-cmr-popup.vue";

@Options({
    components: {
        "order-vehicle-item": OrderVehicleItem,
        UploadCmrPopup,
    },
})
export class OrderVehicleTable extends Vue {
    @Model("_selectedCars", { required: true })
    selectedCars!: Array<OrderVehicleDto>;
    @Prop({ required: true })
    order!: OrderDto;
    @Prop({ required: true })
    orderStatus!: OrderStatus | null;
    @Prop({ required: true })
    orderVehicles!: OrderVehicleDto[];
    @Model("_isPaymentsTransactionsPopup", { required: true })
    isPaymentsTransactionsPopup!: boolean;
    @Model("_orderPaymentDto", { required: true })
    orderPaymentDto!: OrderPaymentDetailsDto;
    @Model("_orderId", { required: true })
    orderId!: number;
    @Prop()
    fetchOrders!: () => void;
    i18n = setup(useI18n);
    payments!: OrderPaymentDetailsDto;
    sortOrder: OrdersSortDirection = OrdersSortDirection.ASC;
    showUpload = true;
    selectAvailable = false;
    async mounted() {
        await this.fetchPayments();
    }
    async fetchPayments() {
        await appAxios.value
            .get<APIResponse<OrderPaymentDetailsDto>>(
                `/client/web/orders/${this.order.id}/payments`,
            )
            .then((response) => {
                this.payments = response.data.data;
            })
            .catch(console.log);
    }
    showPopup = false;
    closePopup() {
        this.showPopup = false;
    }
    changeAmountSortOrder() {
        if (this.sortOrder === OrdersSortDirection.ASC) {
            this.sortOrder = OrdersSortDirection.DESC;
        } else {
            this.sortOrder = OrdersSortDirection.ASC;
        }
    }
}
